module.exports = __webpack_public_path__ + "static/media/notion.c1a019bc.png";